<div class="modal-header">
    <h3 class="modal-title">How to Enable/Disable Pure1 Edge Service</h3>
    <button type="button" class="close modal-x-button pull-right" (click)="activeModal.close()">
        <pureui-svg class="pstg-action-icon" svg="x-action.svg" height="12"></pureui-svg>
    </button>
</div>

<div class="modal-body">
    <div class="description">
        Pure1 Edge Service provides secure communications between management applications in the Pure1 Cloud and
        companion applications on supported Purity//FA systems.
        <a
            href="https://support.purestorage.com/FlashArray/FlashArray_Release/FlashArray_Pure1/The_Pure1_Edge_Service"
            target="_blank"
            >Read Whitepaper</a
        >
    </div>
    <div class="instruction">
        Use the following CLI commands to facilitate two-way communication between your appliance and Pure1. These
        commands also enable agent software changes (install, upgrade, uninstall).
    </div>
    <div class="main-content">
        <div class="submenu-wrapper">
            <ul
                class="nav navbar-nav"
                pureTabGroup
                [selectedTab]="selectedTab"
                (selectedTabChange)="onSelectedTabChange($event)"
            >
                <li
                    *ngFor="let submenuItem of submenuItems"
                    class="nav-item"
                    [ngClass]="{ active: selectedTab === submenuItem }"
                    [pureTabName]="submenuItem"
                >
                    <a class="nav-link" role="button">
                        {{ submenuItem }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="cli-commands">
            <span>{{ cliCommands }}</span>
        </div>
    </div>
</div>
<div class="modal-footer btn-toolbar">
    <div class="footer-msg">
        <pureui-svg svg="info-circle.svg" height="15"></pureui-svg
        ><span
            >Review
            <a
                href="https://support.purestorage.com/Pure1/Pure1_Manage/009_Administration/Pure1_Manage_-_Edge_Service"
                target="_blank"
                >Pure1 Edge Service Best Practices</a
            >
            before enabling the service.</span
        >
    </div>
    <button type="button" class="btn btn-primary ok-button" (click)="activeModal.close()"> OK </button>
</div>
